import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { CheckCircle2, MapPin, Wrench, Map, AlertTriangle, Search, Mail, Signpost, HelpCircle, PhoneCall } from 'lucide-react';
export function Services() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1719">
      <TopBar data-id="element-1720" />
      <Header data-id="element-1721" />
      <Navigation data-id="element-1722" />

      <main className="flex-grow" data-id="element-1723">
        {/* Hero Section */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1724">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1725">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1726">
              Professional Installation & Diagnostics
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1727">
              Comprehensive Mailbox & Sign Services
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-1728">
              Welcome to MidAtlantic Mailbox, Inc., your trusted source for all
              your curbside & streetside needs. Whether you're planning a new
              street sign development, need a community mailbox installed, or
              require expert opinions on identifying models, our experienced
              team ensures your installations are secure and backed by
              professional expertise.
            </p>
          </div>
        </section>

        {/* Residential Services */}
        <section className="py-16 lg:py-24 bg-brand-goldWash border-b border-brand-border" data-id="element-1729">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1730">
            <div className="flex flex-col lg:flex-row gap-12" data-id="element-1731">
              <div className="lg:w-1/2" data-id="element-1732">
                <div className="flex items-center gap-3 mb-6" data-id="element-1733">
                  <div className="w-12 h-12 rounded-full bg-white text-brand-maroon flex items-center justify-center shadow-sm" data-id="element-1734">
                    <Mail size={24} data-id="element-1735" />
                  </div>
                  <h2 className="text-3xl font-serif font-bold text-brand-charcoal" data-id="element-1736">
                    Residential Services
                  </h2>
                </div>
                <p className="text-brand-charcoal/80 mb-8 text-lg" data-id="element-1737">
                  Your Mailbox, Our Mission! We install all types of mailboxes,
                  from standard curbside units to decorative post-mounted
                  designs, ensuring a perfect fit for your property.
                </p>

                <div className="bg-white p-6 rounded-xl border border-brand-border shadow-sm mb-8" data-id="element-1738">
                  <h3 className="font-bold text-brand-charcoal text-xl mb-4 flex items-center gap-2" data-id="element-1739">
                    <Wrench size={20} className="text-brand-maroon" data-id="element-1740" />
                    Installation Services Include:
                  </h3>
                  <ul className="space-y-3 text-brand-muted" data-id="element-1741">
                    <li className="flex items-start gap-2" data-id="element-1742">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1743" />
                      <span data-id="element-1744">Full-Unit Assembly</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1745">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1746" />
                      <span data-id="element-1747">
                        Direct Burial Post Installation in Concrete to USPS
                        Guidelines & Regulatory Height
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1748">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1749" />
                      <span data-id="element-1750">Number Application</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1751">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1752" />
                      <span data-id="element-1753">Removal & Disposal of Old System</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="lg:w-1/2 space-y-6" data-id="element-1754">
                <div className="bg-white p-6 rounded-xl border border-brand-border shadow-sm" data-id="element-1755">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1756">
                    <Search size={20} className="text-brand-maroon" data-id="element-1757" />
                    FREE Diagnostic & Estimating
                  </h3>
                  <p className="text-brand-muted text-sm leading-relaxed" data-id="element-1758">
                    Struggling to identify your exact mailbox manufacturer,
                    model, or replacement part? We’ll diagnose any damage,
                    identify your model/manufacturer, and determine necessary
                    replacement parts. We provide a quote including pricing and
                    lead time, and offer installation within our service area.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl border border-brand-border shadow-sm" data-id="element-1759">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1760">
                    <HelpCircle size={20} className="text-brand-maroon" data-id="element-1761" />
                    HOA & Discontinued Models
                  </h3>
                  <p className="text-brand-muted text-sm leading-relaxed mb-3" data-id="element-1762">
                    <strong data-id="element-1763">Strict HOA Requirements:</strong> With 20 years of
                    industry experience, we can identify your required model via
                    photos and system records to ensure it matches perfectly and
                    avoids penalties.
                  </p>
                  <p className="text-brand-muted text-sm leading-relaxed" data-id="element-1764">
                    <strong data-id="element-1765">Discontinued Models:</strong> For developments 10+
                    years old, models may be discontinued. We provide similar
                    options and recommend notifying your HOA immediately to
                    determine how to proceed. Even if we don't sell your
                    required model, we'll help identify it and point you to the
                    right manufacturer!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Commercial Services */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1766">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1767">
            <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1768">
              <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1769">
                Commercial Mailbox Services
              </h2>
              <p className="text-lg text-brand-muted leading-relaxed" data-id="element-1770">
                Developments, Cluster Boxes, Vertical, and Horizontal
                Multi-Tenant Mailboxes. We offer FREE estimating and diagnostic
                services to provide insight into costs, lead times, and
                regulations.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1771">
              <div className="bg-brand-background p-8 rounded-xl border border-brand-border" data-id="element-1772">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4 flex items-center gap-2" data-id="element-1773">
                  <Map size={24} className="text-brand-maroon" data-id="element-1774" />
                  USPS Route & Development Mapping
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-1775">
                  With 20+ years of experience in commercial mapping and
                  community planning, we provide value-engineered tenant layouts
                  to reduce cost, increase efficiency, and remain in accordance
                  with USPS regulations.
                </p>
                <ul className="space-y-2 text-brand-muted text-sm" data-id="element-1776">
                  <li className="flex items-start gap-2" data-id="element-1777">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1778"></span>
                    <span data-id="element-1779">Estimates based on researched and built layouts</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1780">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1781"></span>
                    <span data-id="element-1782">
                      Access to site plans and recommendations once awarded
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1783">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1784"></span>
                    <span data-id="element-1785">
                      Guidance on USPS approval and address sequencing
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-brand-background p-8 rounded-xl border border-brand-border" data-id="element-1786">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4 flex items-center gap-2" data-id="element-1787">
                  <Wrench size={24} className="text-brand-maroon" data-id="element-1788" />
                  CBU Installation Services
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-1789">
                  Managing a Cluster Box Unit (CBU) replacement or new
                  development can be daunting. Let us take the reins of the
                  installation while adhering to USPS postal codes.
                </p>
                <ul className="space-y-2 text-brand-muted text-sm" data-id="element-1790">
                  <li className="flex items-start gap-2" data-id="element-1791">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1792"></span>
                    <span data-id="element-1793">Address Sequencing Approved by USPS</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1794">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1795"></span>
                    <span data-id="element-1796">
                      Communications with local postal service to manage
                      schedule
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1797">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1798"></span>
                    <span data-id="element-1799">
                      Individual key testing and house address labeling
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1800">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1801"></span>
                    <span data-id="element-1802">Removal & Disposal of Old System</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Commercial FAQs */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1803">
              <div className="border border-brand-border rounded-lg p-5" data-id="element-1804">
                <h4 className="font-bold text-brand-charcoal mb-2 text-sm" data-id="element-1805">
                  Need to replace a CBU part?
                </h4>
                <p className="text-sm text-brand-muted" data-id="element-1806">
                  Email a photo of the damaged unit/part. We'll diagnose the
                  model, year, and part ID, then provide a quote based on
                  manufacturer lead time.
                </p>
              </div>
              <div className="border border-brand-border rounded-lg p-5" data-id="element-1807">
                <h4 className="font-bold text-brand-charcoal mb-2 text-sm" data-id="element-1808">
                  Large project starting point?
                </h4>
                <p className="text-sm text-brand-muted" data-id="element-1809">
                  We'll ask guided questions to jumpstart the process and
                  provide options based on your specific development needs.
                </p>
              </div>
              <div className="border border-brand-border rounded-lg p-5" data-id="element-1810">
                <h4 className="font-bold text-brand-charcoal mb-2 text-sm" data-id="element-1811">
                  Carrier denying delivery?
                </h4>
                <p className="text-sm text-brand-muted" data-id="element-1812">
                  Contact your local post office to determine the cause (damaged
                  locks, noncompliance). We can then quote the necessary code
                  updates.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* USPS Compliance & Mailbox Types */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1813">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1814">
            <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-1815">
              Commercial Mailbox Compliance
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1816">
              {/* 4C Mailboxes */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1817">
                <h3 className="font-bold text-brand-charcoal text-xl mb-3" data-id="element-1818">
                  4C USPS Approved Mailboxes
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-1819">
                  Centralized, multi-unit mailboxes designed for commercial mail
                  delivery. Commonly found in apartments, commercial buildings,
                  and new residential developments.
                </p>
                <ul className="space-y-2 text-brand-muted text-sm" data-id="element-1820">
                  <li className="flex items-start gap-2" data-id="element-1821">
                    <CheckCircle2 size={16} className="text-brand-green shrink-0 mt-0.5" data-id="element-1822" />
                    <span data-id="element-1823">
                      Compliant with the newest USPS STD-4C Regulations
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1824">
                    <CheckCircle2 size={16} className="text-brand-green shrink-0 mt-0.5" data-id="element-1825" />
                    <span data-id="element-1826">
                      Numerous pre-configured modules and colors available
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1827">
                    <CheckCircle2 size={16} className="text-brand-green shrink-0 mt-0.5" data-id="element-1828" />
                    <span data-id="element-1829">Includes locks with 3 keys per tenant slot</span>
                  </li>
                </ul>
              </div>

              {/* 4B+ Warning */}
              <div className="bg-brand-maroon/5 p-8 rounded-xl border border-brand-maroon/20 shadow-sm relative overflow-hidden" data-id="element-1830">
                <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-1831">
                  <AlertTriangle size={100} className="text-brand-maroon" data-id="element-1832" />
                </div>
                <h3 className="font-bold text-brand-maroon text-xl mb-3 flex items-center gap-2 relative z-10" data-id="element-1833">
                  <AlertTriangle size={24} data-id="element-1834" />
                  4B+ Horizontal & Vertical Mailboxes
                </h3>
                <p className="text-brand-charcoal/80 mb-4 relative z-10 font-medium" data-id="element-1835">
                  Phased out for new installations as of October 2006.
                </p>
                <div className="space-y-3 text-sm text-brand-charcoal/70 relative z-10" data-id="element-1836">
                  <p data-id="element-1837">
                    USPS requires properties to be updated to current standards
                    (CBU or 4C) when any renovation occurs. Confirm USPS
                    approval prior to purchase as these are non-refundable if
                    denied.
                  </p>
                  <p className="font-semibold text-brand-maroon" data-id="element-1838">
                    *MidAtlantic Mailbox, Inc. will not install 4B+ Horizontal
                    and Vertical Mailboxes without direct Postmaster Approval.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Street Signs */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1839">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1840">
            <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-1841">
              <div className="lg:w-1/3 flex justify-center" data-id="element-1842">
                <div className="w-32 h-32 rounded-full bg-brand-goldWash flex items-center justify-center border-4 border-white shadow-lg" data-id="element-1843">
                  <Signpost size={64} className="text-brand-charcoal" data-id="element-1844" />
                </div>
              </div>
              <div className="lg:w-2/3" data-id="element-1845">
                <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1846">
                  Street Signs & Traffic Signs
                </h2>
                <p className="text-lg text-brand-muted mb-6" data-id="element-1847">
                  Decorative and Municipality Sign Systems. We specialize in
                  street-planning, full-system replacements, decorative street
                  sign packages, and replacement parts.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-1848">
                  <div data-id="element-1849">
                    <h4 className="font-bold text-brand-charcoal mb-2" data-id="element-1850">
                      FREE Estimating & Diagnostics
                    </h4>
                    <p className="text-sm text-brand-muted" data-id="element-1851">
                      Trouble finding an exact model? We help identify the
                      model, manufacturer, and size of parts needed, or provide
                      the best visual match if discontinued.
                    </p>
                  </div>
                  <div data-id="element-1852">
                    <h4 className="font-bold text-brand-charcoal mb-2" data-id="element-1853">
                      Installation Services
                    </h4>
                    <p className="text-sm text-brand-muted" data-id="element-1854">
                      Over 10 years of experience installing standard and
                      decorative systems per manufacturer guidelines, DOT
                      regulations, and municipality preferences. Includes
                      removal of old systems.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Area & CTA */}
        <section className="py-16 lg:py-24 bg-brand-charcoal text-white text-center" data-id="element-1855">
          <div className="max-w-4xl mx-auto px-4" data-id="element-1856">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-maroon mb-6" data-id="element-1857">
              <MapPin size={32} className="text-white" data-id="element-1858" />
            </div>
            <h2 className="text-3xl font-serif font-bold mb-6" data-id="element-1859">
              Our Installation Service Area
            </h2>
            <p className="text-lg text-gray-300 mb-8" data-id="element-1860">
              We proudly provide professional installation services to parts of:
            </p>
            <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-1861">
              {['Maryland', 'Pennsylvania', 'Washington D.C.', 'Virginia', 'West Virginia'].map(state => <span key={state} className="bg-white/10 border border-white/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-1862">
                  {state}
                </span>)}
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-1863">
              <h3 className="text-2xl font-bold mb-4" data-id="element-1864">Get Started Today!</h3>
              <p className="text-gray-300 mb-8" data-id="element-1865">
                MidAtlantic Mailbox is here to help with all your mailbox and
                street-sign needs. Contact us today for a free consultation.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1866">
                <a href="tel:301-620-7585" className="bg-brand-gold hover:bg-brand-gold/90 text-brand-charcoal px-8 py-4 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto flex items-center justify-center gap-2 text-lg" data-id="element-1867">
                  <PhoneCall size={20} data-id="element-1868" />
                  Call 301-620-7585
                </a>
                <a href="/ContactUs.html" className="bg-transparent border-2 border-white hover:bg-white hover:text-brand-charcoal text-white px-8 py-4 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto text-lg" data-id="element-1869">
                  Contact Us Online
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1870" />
      <MobileStickyBar data-id="element-1871" />
    </div>;
}